import {
  ActionIcon,
  Group,
  Menu,
  Text,
  Tooltip,
  useMantineColorScheme,
} from "@mantine/core";
import { IconCheck, IconMoon, IconPalette, IconSun } from "@tabler/icons-react";
import { BRAND_PALETTE_OPTIONS } from "../theme/brandPalettes";
import { useBrandTheme } from "../theme/BrandThemeContext";

export function ColorSchemeToggle() {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const { palette, paletteKey, setPaletteKey } = useBrandTheme();

  return (
    <Group gap={6} wrap="nowrap">
      <Menu position="bottom-end" shadow="md" width={250}>
        <Menu.Target>
          <Tooltip label={`Brand palette: ${palette.label}`}>
            <ActionIcon
              variant="default"
              size="lg"
              aria-label={`Choose brand palette. Current palette: ${palette.label}`}
            >
              <IconPalette color={palette.primary} size={18} />
            </ActionIcon>
          </Tooltip>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Label>NextGen brand palette</Menu.Label>
          {BRAND_PALETTE_OPTIONS.map((option) => (
            <Menu.Item
              key={option.key}
              onClick={() => setPaletteKey(option.key)}
              leftSection={
                <span
                  aria-hidden
                  style={{
                    background: option.primary,
                    border: `2px solid ${option.accent}`,
                    borderRadius: "50%",
                    display: "block",
                    height: 16,
                    width: 16,
                  }}
                />
              }
              rightSection={
                option.key === paletteKey ? <IconCheck size={16} /> : null
              }
            >
              <Text fw={600} size="sm">
                {option.label}
              </Text>
              <Text c="dimmed" size="xs" lh={1.2}>
                {option.description}
              </Text>
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>
      <Tooltip label={colorScheme === "dark" ? "Use light mode" : "Use dark mode"}>
        <ActionIcon
          variant="default"
          size="lg"
          onClick={toggleColorScheme}
          aria-label="Toggle light and dark theme"
        >
          {colorScheme === "dark" ? (
            <IconSun size={18} />
          ) : (
            <IconMoon size={18} />
          )}
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}
